"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedEnvironment = void 0;

/*
* Returns the auto-selected environment for the 'Rollout' tab
*
  query getExperimentEnvironments($id: Int!) {
    experiment(id: $id) {
      id
      name
      experimentStatus {
        id
        name
      }
      environmentSamplings {
        id
        environment {
          id
          name
          order
          color
        }
        experimentStatus {
          id
          name
        }
      }
    }
  }
*/
const getSelectedEnvironment = (experiment, selectedId = null) => {
  const {
    environmentSamplings
  } = experiment;
  const sortedSamplings = environmentSamplings && environmentSamplings.length ? environmentSamplings.slice().sort((aSampling, bSampling) => {
    if (aSampling.environment && bSampling.environment) {
      return aSampling.environment.order < bSampling.environment.order ? 1 : -1;
    } else {
      return -1;
    }
  }) : [];

  if (selectedId) {
    const environmentFormat = sortedSamplings.find(sampling => sampling && sampling.environment && sampling.environment.id === selectedId);

    if (environmentFormat) {
      return formatEnvironment(environmentFormat);
    } else {
      return {
        id: 1,
        order: 1,
        sampleAllocation: 0,
        tdcsUpdateRequired: undefined,
        isDreSynced: undefined,
        color: '',
        name: '',
        status: '',
        experimentStatusId: 1
      };
    }
  }

  let selectedEnvironment = formatEnvironment(sortedSamplings[0]);
  sortedSamplings.forEach(sampling => {
    if (sampling && sampling.environment && selectedEnvironment && sampling.experimentStatus && sampling.environment.order < selectedEnvironment.order && sampling.experimentStatus.id > selectedEnvironment.experimentStatusId) {
      selectedEnvironment = formatEnvironment(sampling);
    }
  });
  return selectedEnvironment;
};

exports.getSelectedEnvironment = getSelectedEnvironment;

const formatEnvironment = ({
  environment,
  experimentStatus,
  tdcsUpdateRequired,
  isDreSynced,
  sampleAllocation
}) => ({ ...environment,
  sampleAllocation,
  tdcsUpdateRequired,
  isDreSynced,
  name: environment ? environment.name.toLowerCase() : '',
  status: experimentStatus ? experimentStatus.name.toLowerCase() : '',
  experimentStatusId: experimentStatus ? experimentStatus.id : 0
});